<app-search-template searchLabel="Search" [showSearchButton]=true [reset]=true [showLocations]=false [showDevelopments]=false
  [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=false [showSeasons]=false
  [showStartDate]=true [showEndDate]=true
  (doSearchCB)="onSearchSubmit($event)">
</app-search-template>

@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<h2>Reservation Ledger Summary</h2>
<ag-grid-angular
  style="width: auto; height: auto; margin: 20px 0px;"
  class="ag-theme-balham"
  [gridOptions]="gridOptions"
  [rowData]="reservationLedgers"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="onFirstDataRendered($event)"
  [groupDefaultExpanded]="groupDefaultExpanded"
  (rowGroupOpened)="onRowGroupOpened($event)"
  >
</ag-grid-angular>